import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import {useModalAction} from '@/_application/core/components/ui/modal/modal.context';
import {Icons, mobileShortcuts} from '@/framework/static/shortcuts';
import {authorizationAtom} from '@/store/authorization-atom';
import {isCategoryModelOpenAtom} from '@/store/mobile-layout/mobile-layout';
import {useAtom} from 'jotai';
import {useRouter} from 'next/navigation';
import React from 'react';

const HomeCatalog: React.FC = () => {
    const {openModal} = useModalAction();
    const [isAuthorized] = useAtom(authorizationAtom);
    const [, setIsCategoryModelOpen] = useAtom(isCategoryModelOpenAtom);
    const router = useRouter();

    const handleClick = (icon: Icons) => {
        switch (icon.key) {
            case 'tra_cuu_don_hang':
                isAuthorized ? router.push(icon.url) : openModal('LOGIN_VIEW');
                break;

            case 'danh_muc':
                setIsCategoryModelOpen(true);
                break;

            default:
                router.push(icon.url);
                break;
        }
    };

    return (
        <div className="grid w-full grid-cols-5 gap-3 bg-white pb-2 pt-12">
            {mobileShortcuts.map((icon: Icons) => {
                return (
                    <IconButton
                        key={icon.key}
                        whileTap={{scale: 0.9, opacity: 0.5}}
                        transition={{type: 'spring', stiffness: 400, damping: 17}}
                        onClick={() => handleClick(icon)}
                        className="mt-2 flex flex-col content-center items-center justify-start"
                        icon={
                            <div className="h-9">
                                <Image
                                    src={icon.image}
                                    alt={`${icon.title} icon`}
                                    width={34}
                                    height={34}
                                    className="h-full w-auto"
                                />
                            </div>
                        }
                        label={icon.title}
                        labelClassName="mt-2 max-w-[53px] text-center text-xs"
                    />
                );
            })}
        </div>
    );
};

export default HomeCatalog;
